// Screen Wake Lock API (Chrome, Safari 16.4+, Android webviews). Silently does nothing if unsupported.
type Sentinel = { release: () => Promise<void> };
let sentinel: Sentinel | null = null;
let wanted = false;

async function acquire() {
  const wakeLock = (navigator as unknown as { wakeLock?: { request: (t: 'screen') => Promise<Sentinel> } }).wakeLock;
  if (!wakeLock) return;
  try {
    sentinel = await wakeLock.request('screen');
  } catch {
    sentinel = null;
  }
}

// The browser drops the lock when the tab is hidden; re-acquire on return.
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (wanted && document.visibilityState === 'visible') acquire();
  });
}

export function activateKeepAwake(): void {
  wanted = true;
  acquire();
}

export function deactivateKeepAwake(): void {
  wanted = false;
  sentinel?.release().catch(() => {});
  sentinel = null;
}
